module.exports = __webpack_public_path__ + "img/image_bcra.5b7c2264.png";